module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch10"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch10aa"
    }
  }), _c('a', {
    attrs: {
      "id": "ch10a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch10"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("MR. BLACK & MS. WHITE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("Thoughts from the gray matter of people named Black and White.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“I never had much of a vocabulary. My friend would still be alive today if I’d known the difference between "), _c('i', [_vm._v("antidote")]), _vm._v(" and "), _c('i', [_vm._v("anecdote")]), _vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—Ron White, comedian")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“MTV is to music as KFC is to chicken.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—Lewis Black, comedian")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“I would never purposely sing a song about someone I love, I wouldn’t want to embarrass them. But for someone I don’t like, I’d definitely do that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—Jack White, the White Stripes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“The moment you start analyzing your own rock is the moment your rock is dead. That’s why rock is now pretty much dead. Too much analyzation. Not enough rockalyzation!”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—Jack Black, Tenacious D")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“The most difficult thing in the world is to know how to do a thing and to watch someone else do it wrong without comment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—T. H. White, author")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“The easiest lies to tell are the ones you want to be true.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—Holly Black, author")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“All creatures must learn to coexist. That’s why the brown bear and the field mouse can share their lives in harmony. Of course, they can’t mate or the mice would explode.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—Betty White, actor")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“The layman’s constitutional view: What he likes is constitutional, and that which he doesn’t is unconstitutional.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—"), _c('b', [_vm._v("Hugo Black, Supreme Court Justice")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“Analyzing humor is like dissecting a frog. Few people are interested and the frog dies of it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—E. B. White, author")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“The only easy day was yesterday.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—Clint Black, country star")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“Cement doesn’t give as much as snow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('b', [_vm._v("—Shaun White, champion snowboarder, on why he doesn’t skateboard")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("What is the white powder on chewing gum? Powdered sugar or talc, usually.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2ed4ece","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter010.vue
// module id = 108
// module chunks = 0